<div class="combo-bet-header__content" *ngIf="vm$ | async as vm">
    <div class="combo-bet-header__title-container">
        <div class="combo-bet-header__title">
            <div>{{ vm.messages.title }}</div>
            <i class="combo-bet-header__icon theme-info" (click)="openBetbuilderInfoMessage()"></i>
        </div>
        <div class="combo-bet-header__subtitle">{{ vm.messages.subTitle }}</div>
    </div>
    <div class="combo-bet-header__odds">{{ formattedOdds(vm.summary.totalOdds) }}</div>
    <div class="theme-ex" (click)="removeAllPick()"></div>
</div>

<bs-digital-combo-bet-betbuilder-info-message
    *ngIf="showBetbuilderInfoMessage"
    [infoMessage]="infoMessage"
    [infoHeaderTitle]="infoHeaderTitle"
    [infoHeader]="infoHeader"
    (close)="closeBetbuilderInfoMessage()"></bs-digital-combo-bet-betbuilder-info-message>
